import { Product } from '../models/product.interface';

export function calculateTotal(products: Product[]): number {
  return products.reduce((total, product) => {
    const amount = product.pivot?.amount ?? product.amount ?? 0;
    const price = product.price ?? 0;
    const bediengeld = product.bediengeld ?? 0;

    const productTotal = amount * price;
    const bediengeldTotal = amount * bediengeld;
    return total + productTotal + bediengeldTotal;
  }, 0);
}

export function selectedPackageBediengeldAmount(products: Product[]): number {
  return products.reduce((totalAmount, product) => {
    const amount = product.pivot?.amount ?? 0;
    const bediengeld = product.bediengeld ?? 0;

    // Berücksichtigt nur Produkte mit Bediengeld > 0
    return bediengeld > 0 ? totalAmount + amount : totalAmount;
  }, 0);
}

export function selectedPackageBediengeld(products: Product[]): number {
  return products.reduce((total, product) => {
    const amount = product.pivot?.amount ?? 0;
    const bediengeld = product.bediengeld ?? 0;

    // Multipliziert Bediengeld mit der Anzahl (pivot.amount)
    return total + amount * bediengeld;
  }, 0);
}
